import { css } from '@styled-system/css';
import { Interpolation } from 'styled-components';

export type SXProps = {
  sx?: {
    borderBottomColor?: string;
    float?: 'right';
    marginLeft?: 'auto';
    resize?: 'none';
    whiteSpace?: 'nowrap';
  };
};

export const sx = ((props: SXProps) => css(props.sx)) as Interpolation<object>;
